import axios from 'axios';
import c from '../helpers/constants';
import { getApiKey } from '../helpers/functions';

export function getProductTypes(customerId: string) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.PRODUCT_TYPES}?customerid=${encodeURIComponent(customerId)}`,
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'x-api-key': getApiKey()
      },
    })
      .then((response: any) => {
        return response?.data;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}
